import React from "react";
import { useParams } from "react-router-dom";
import { useFetchVesselById } from "../Utils/useFetchVesselById";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./vesseldetails.css"

const VesselDetails = () => {
  const { id } = useParams();
  const { data: vessel, isLoading, error } = useFetchVesselById(id);
  console.log(vessel)

  if (isLoading) return <Skeleton count={10} />;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className="vessel-details-container">
      <h1>Vessel Details</h1>
      <p>MMSI: {vessel.vesselInformation?.mmsiNumber}</p>
      <p>IMO: {vessel.vesselInformation?.imoNumber}</p>
      <p>Type: {vessel.primaryInformation?.vesselType}</p>
      <p>Price: {vessel.primaryInformation?.pricing}</p>
      <img src={vessel.images[0]} alt="Vessel" />
    </div>
  );
};

export default VesselDetails;
